module.exports = __webpack_public_path__ + "img/1.cf4124a8.jpg";